var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommentAddIconOutlined(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_652_2662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.66634 3.33341C1.66634 2.41675 2.41634 1.66675 3.33301 1.66675H16.6663C17.583 1.66675 18.333 2.41675 18.333 3.33341V13.3334C18.333 14.2501 17.583 15.0001 16.6663 15.0001H4.99967L1.66634 18.3334V3.33341ZM3.33301 14.3084L4.30801 13.3334H16.6663V3.33341H3.33301V14.3084ZM9.16634 4.16675H10.833V7.50008H14.1663V9.16675H10.833V12.5001H9.16634V9.16675H5.83301V7.50008H9.16634V4.16675Z",
    fill: "#A1B5BC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_652_2662"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "matrix(-1 0 0 1 20 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentAddIconOutlined);
export default __webpack_public_path__ + "static/media/comment-add-icon-outlined.d54a9d49a25d066695ccd77703c4012f.svg";
export { ForwardRef as ReactComponent };